export default "__VITE_ASSET__DAmeBVoh__"